import React from "react";
import { useTranslation } from 'react-i18next';
import BuildMyChecksSocialLinks from './BuildMyChecksSocialLinks';

export default function Footer() {
  const { t } = useTranslation();
  const websiteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "BuildMyChecks",
    "url": "https://buildmychecks.com"
  };

  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "BuildMyChecks",
    "url": "https://buildmychecks.com",
    "logo": "https://buildmychecks.com/logo512.png",
    "sameAs": [
      "https://www.linkedin.com/company/buildmychecks/",
      "https://twitter.com/buildmychecks",
      "https://www.instagram.com/buildmychecks/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Support",
      "email": "support@buildmychecks.co.uk"
    }
  };

  return (
    <footer className="mt-8 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-400 text-sm">
      <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="font-semibold text-gray-800 dark:text-gray-100">BuildMyChecks</div>
          <a href="https://buildmychecks.com" target="_blank" rel="noopener noreferrer" className="text-rose-700 dark:text-rose-400 hover:underline">
            https://buildmychecks.com
          </a>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://buildmyshifts.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-3 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-full text-xs font-medium hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors"
          >
            <span>Try BuildMyShifts</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
          </a>
        </div>

        <div className="text-xs text-gray-500 dark:text-gray-400">
          <div>{t('footer.contact')}</div>
          <div className="flex gap-3 mb-3">
            <a href="/guide" className="underline hover:text-rose-700 dark:hover:text-rose-400">{t('nav.howToGuide')}</a>
            <span>&bull;</span>
            <a href="/delete-account" className="underline hover:text-rose-700 dark:hover:text-rose-400">{t('nav.deleteAccount')}</a>
          </div>
          <BuildMyChecksSocialLinks className="flex items-center gap-3 justify-center sm:justify-start" linkClassName="text-gray-500 dark:text-gray-400 hover:text-rose-700 dark:hover:text-rose-400 transition-colors" />
        </div>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }} />
    </footer>
  );
}
